import { camelCase } from 'lodash';
import { func, object } from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ApiImg, Icon } from 'components';
import { formatLocalizedCurrency, getSubTypeLogo } from 'helpers';
import { useUser } from 'hooks';

const TravelPromote = ({ promote, goToProductSow }) => {
  const { t } = useTranslation();
  const { currentUser, isLaposteEmployee } = useUser();

  const showSubTypeLogo = useMemo(() => {
    /*
			TODO : Temporary condition to show the subType logo
			Remove this once the backend is ready to send the logo display condition

			-> Only LaPoste employees can see the Cogas logo
		*/
    if (isLaposteEmployee && promote.typeItem === 1 && promote.subType === 'Cogas') {
      return true;
    }
    return false;
  }, [currentUser, promote]);

  return (
    <div className="flex flex-col h-full rounded-lg shadow-lg overflow-hidden relative">
      <button type="button" className="opacity-0 absolute inset-0" onClick={goToProductSow}>
        {t('products:productShowCta', { title: promote?.title || '' })}
      </button>

      <div className="aspect-square overflow-hidden shrink-0 sm:aspect-video">
        <ApiImg src={promote.vignette} />
      </div>

      <div className="flex flex-col gap-4 p-6 grow h-full">
        <h3 className="h3 truncate-line three-lines">{promote.title}</h3>

        <hr className="w-10 border-t-yellow-500 border-t-[0.13rem]" />

        <div className="grow flex flex-col justify-center gap-4">
          <h4 className="h4 text-sm">{promote.subtitle}</h4>
          <p>
            <span className="text-sm">{t('fromPrice')}</span>
            <span className="text-secondary-500 mx-1 text-lg font-medium">
              {formatLocalizedCurrency(promote.price, {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
                style: 'currency',
                currency: 'EUR'
              })}
            </span>
            <span className="text-sm">{t('unitPrice')}</span>
          </p>
        </div>

        {(promote.country || promote.city) && <hr className="w-10 border-t-yellow-500 border-t-[0.13rem]" />}

        <div className="flex justify-between items-center flex-wrap">
          <div className="flex gap-2 items-center">
            {(promote.country || promote.city) && (
              <Icon name="location-dot" iconStyle="fad" classes="text-primary-500" />
            )}
            <p>{`${promote.country ?? ''} ${promote.city ? `- ${promote.city}` : ''}`}</p>
          </div>

          {showSubTypeLogo && getSubTypeLogo(promote.subType) && (
            <img
              src={getSubTypeLogo(promote.subType)}
              className="h-7"
              alt={t(`alts.${camelCase(promote.subType)}`)}
              height="20"
              width="57"
            />
          )}
        </div>
      </div>
    </div>
  );
};

TravelPromote.propTypes = {
  promote: object.isRequired,
  goToProductSow: func.isRequired
};

export default TravelPromote;
